var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:none;}.cls-2{clip-path:url(#clippath-1);}.cls-5{fill:#b6c4d8;}.cls-6{fill:#8e9eb2;}.cls-7{fill:#aabccc;}.cls-8{fill:#a4b2c1;}.cls-9{fill:#cfd6e2;}.cls-10{fill:#d0dbec;}.cls-11{fill:#c6d2e0;}.cls-3{stroke:#e6e6e6;stroke-miterlimit:10;}.cls-4{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: -120,
    width: 100,
    height: 100
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 120,
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    y1: -50,
    x2: 100,
    y2: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    y1: -40,
    x2: 100,
    y2: 10.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    y1: -30,
    x2: 100,
    y2: 20.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 100,
    y1: -50,
    x2: 0,
    y2: 0.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 100,
    y1: -40,
    x2: 0,
    y2: 10.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 100,
    y1: -30,
    x2: 0,
    y2: 20.73
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    y1: 100,
    x2: 100,
    y2: 150.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    y1: 90,
    x2: 100,
    y2: 140.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    y1: 80,
    x2: 100,
    y2: 130.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 100,
    y1: 100,
    x2: 0,
    y2: 150.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 100,
    y1: 90,
    x2: 0,
    y2: 140.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 100,
    y1: 80,
    x2: 0,
    y2: 130.73
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m0,34.1c0,3.12,1.07,5.34,2.77,6.43h.16l2.14,1.43c1.64-.48,3.23-1.12,4.74-1.93,5.39-3.12,9.75-10.85,9.72-17.2-.03-1.66-.15-3.32-.36-4.96l-2.2-1.41c-.21-.15-.42-.28-.65-.39-.84-.36-1.74-.54-2.66-.52s-1.81.25-2.63.66c-.45.19-.89.41-1.31.65-2.08,1.28-3.89,2.97-5.31,4.96C1.72,25.35.17,29.64,0,34.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m4.13,34.23c0,2.55.9,4.35,2.3,5.19l.13.08,74.29,40.78c.19.13.42.2.66.2.23,0,.46-.08.65-.21.19-.13.34-.32.42-.54.08-.22.09-.46.03-.68-.1-.56-.15-1.12-.15-1.69v-.71c.07-1.14.27-2.26.61-3.35,1.1-3.9,3.54-7.29,6.9-9.56l.21-.13.48-.26c.47-.24.96-.43,1.47-.57,1.14-.36,2.38-.27,3.45.26l-2.3-1.34-1.06-.61L17.49,20.06l-.25-.15c-.86-.35-1.8-.48-2.72-.37-.92.11-1.81.45-2.56.99l-.21.13c-2.54,1.68-4.56,4.03-5.84,6.79-.95,1.91-1.52,3.99-1.68,6.11-.07.22-.11.45-.1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.15,33.53l78.34,43.12,3,1.73c.2.14.43.21.67.21s.47-.07.67-.21c.19-.14.34-.34.42-.56.08-.23.08-.47.01-.7-.14-.68-.21-1.37-.21-2.06.08-3.11.97-6.15,2.59-8.81.54-.93,1.15-1.82,1.84-2.65.23-.29.46-.55.7-.81.13-.13.23-.28.29-.46.06-.17.08-.36.05-.54-.03-.18-.1-.35-.2-.5-.11-.15-.25-.27-.41-.35l-.26-.15L17.49,20.07l-.25-.15c-.86-.35-1.8-.48-2.72-.37-.92.11-1.81.45-2.56.99l-.21.13c-.72.45-1.4.97-2.02,1.55-3.17,2.97-5.16,6.99-5.58,11.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m9.65,22.17l77.23,42.49,2.74,1.58.26.16c.2.16.44.25.69.26.25,0,.5-.07.7-.21.2-.15.36-.35.43-.59.07-.24.07-.5-.02-.73-.1-.5-.16-1.01-.18-1.53v-.52c0-.52.02-1.04.08-1.56.03-.23-.01-.46-.12-.66-.1-.2-.27-.37-.47-.48L17.48,20.06l-.25-.15c-.86-.35-1.8-.48-2.72-.37-.92.11-1.81.45-2.56.99l-.21.13c-.74.43-1.44.94-2.08,1.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m78.32,77.22c-.03,1.35.22,2.69.74,3.93.41.99,1.09,1.84,1.96,2.45l1.98,1.15c.15.09.32.15.49.17.18.02.35,0,.52-.07,1.42-.48,2.79-1.08,4.11-1.79,5.39-3.13,9.75-10.84,9.73-17.2-.04-1.54-.19-3.07-.44-4.59-.03-.17-.09-.33-.19-.48-.1-.14-.23-.26-.38-.35l-1.78-1.07-.28-.17c-.77-.36-1.6-.54-2.45-.55-.85,0-1.68.16-2.46.5-.64.23-1.26.51-1.84.86-1.97,1.19-3.69,2.75-5.06,4.59-2.84,3.61-4.47,8.02-4.65,12.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m83.94,63.44c-.13.14-.23.31-.28.5-.05.19-.05.38,0,.57.05.19.14.36.27.5.13.14.3.25.48.31,1.84.71,4.91,1.56,5.87,1.01l.21-.13c1.31-.83,2.47-1.87,3.45-3.08.12-.13.2-.28.25-.45s.06-.34.02-.52c-.03-.17-.1-.33-.2-.47-.1-.14-.24-.26-.39-.34l-3.24-1.93c-.16-.1-.35-.15-.54-.16-.19-.01-.38.02-.55.09-.43.18-.85.4-1.25.63-1.53.93-2.91,2.1-4.08,3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m90.29,84.38c5.39-3.1,9.74-10.83,9.71-17.21-.02-6.38-4.42-9.03-9.81-5.89-5.39,3.13-9.75,10.8-9.72,17.19.02,4.57,2.27,7.21,5.53,7.21,1.52-.05,3-.5,4.29-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m7.78,22.87c-1.14-.26-2.25-.61-3.33-1.06,1.42-1.99,3.23-3.67,5.31-4.96.43-.24.86-.46,1.31-.65,1.15.68,2.3,1.34,3.38,2-1.49,1.44-6.35,4.04-6.67,4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m83.83,71.24c1.27-3.05,3.42-5.66,6.17-7.49l.21-.13c2.08-1.15,3.98-1.33,5.38-.57l.19.13c1.38.86,2.24,2.65,2.24,5.15-.11,3.39-1.24,6.68-3.23,9.43-1.14,1.67-2.61,3.1-4.31,4.19l-.21.13c-1.14.73-2.47,1.08-3.82,1.02-.56-.04-1.11-.2-1.6-.47-.52-.28-.97-.67-1.32-1.15-.77-1.21-1.15-2.62-1.09-4.05.03-2.14.5-4.25,1.38-6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m2.33,37.43c.11.93.42,1.83.93,2.63.5.79,1.18,1.46,1.98,1.96.86.39,1.8.59,2.75.57.95-.02,1.88-.25,2.73-.67l-2.38-1.38c-.83-.41-1.63-.89-2.38-1.43-2.44-2.02-2.04-6.01-1.28-8.69.08-.28.16-.55.25-.83,1-3.08,2.83-5.81,5.29-7.92,1.98-1.65,4.79-3.02,7.25-1.61l4.09,2.4c-.07-1.06-.4-2.09-.97-2.99-.57-.9-1.36-1.63-2.3-2.14-1.06-.37-2.2-.48-3.31-.33-1.11.15-2.18.56-3.1,1.2-2.3,1.41-4.26,3.31-5.75,5.56-1.08,1.56-1.98,3.24-2.68,5-1.16,2.73-1.55,5.72-1.13,8.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m82.49,77.37c-.04,1.32.28,2.63.92,3.78.11.16.25.3.42.4l2.42,1.4c.17.11.36.16.56.16,1.22-.03,2.41-.39,3.45-1.04l.21-.13c1.31-.84,2.48-1.88,3.46-3.1.12-.13.2-.28.25-.45s.06-.34.02-.52c-.03-.17-.1-.33-.2-.47-.1-.14-.24-.26-.39-.34l-8.6-5.1c-.15-.1-.32-.16-.5-.18-.18-.02-.36,0-.53.06-.17.06-.32.16-.44.29-.12.13-.21.29-.27.46-.52,1.54-.79,3.15-.78,4.77Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipes);
export default __webpack_public_path__ + "static/media/pipes.da4cb6577349f11ccd1ad8787939bc07.svg";
export { ForwardRef as ReactComponent };